const periodontology = {
  hero: {
    topLine: "Spezialisten für Zahnfleischgesundheit",
    titleLine1: "Fortschrittliche Parodontologie",
    titleLine2: "für gesundes Zahnfleisch",
    description:
      "Unsere spezialisierten Parodontalbehandlungen behandeln Zahnfleischerkrankungen und fördern die Mundgesundheit mit fortschrittlichen, minimalinvasiven Techniken.",
    ctas: {
      primary: "Beratungstermin vereinbaren",
      secondary: "Mehr erfahren",
    },
    imageAlt: "Fortschrittliche Parodontalbehandlung",
    stats: {
      value: "98%",
      label: "Erfolgsquote",
    },
    floatingLabel: "Zahnfleischrekonstruktion",
  },
  benefits: {
    heading: "WARUM UNSERE PARODONTALPFLEGE WÄHLEN",
    intro:
      "Erleben Sie umfassende Parodontalbehandlungen mit Schwerpunkt auf Prävention und langfristiger Zahnfleischgesundheit.",
    items: [
      {
        title: "Prävention von Zahnfleischerkrankungen",
        description:
          "Unsere Behandlungen helfen, Parodontitis zu verhindern und zu behandeln, schützen Ihre Zähne vor Verlust und bewahren Ihr Lächeln.",
      },
      {
        title: "Verbesserte allgemeine Gesundheit",
        description:
          "Gesundes Zahnfleisch trägt zu einer besseren allgemeinen Gesundheit bei, indem es Entzündungen und das Risiko bakterieller Infektionen reduziert.",
      },
      {
        title: "Früherkennung",
        description:
          "Wir identifizieren und behandeln Parodontalprobleme frühzeitig und verhindern so das Fortschreiten zu schwerwiegenderen Zuständen.",
      },
    ],
  },
  process: {
    heading: "UNSER PARODONTALBEHANDLUNGSPROZESS",
    intro:
      "Ein systematischer Ansatz zur Diagnose und Behandlung von Parodontalerkrankungen für eine optimale Zahnfleischgesundheit",
    stepLabel: "Schritt",
    items: [
      {
        title: "Umfassende Beurteilung",
        description:
          "Gründliche Untersuchung Ihres Zahnfleisches, Messung der Taschentiefen und Überprüfung auf Entzündungen und Blutungen.",
      },
      {
        title: "Diagnose & Planung",
        description:
          "Detaillierte Diagnose Ihres Parodontalzustands und Erstellung eines persönlichen Behandlungsplans.",
      },
      {
        title: "Spezialisierte Behandlung",
        description:
          "Fortschrittliche Parodontaltherapien einschließlich Zahnsteinentfernung, Wurzelglättung und Laserbehandlungen bei Bedarf.",
      },
      {
        title: "Erhaltung & Nachsorge",
        description:
          "Regelmäßige Kontrolluntersuchungen und Pflege, um die langfristige Gesundheit Ihres Zahnfleisches zu gewährleisten und ein Wiederauftreten zu verhindern.",
      },
    ],
  },
  faq: {
    heading: "HÄUFIG GESTELLTE FRAGEN",
    intro:
      "Erhalten Sie Antworten auf häufige Fragen zur Parodontalgesundheit und Behandlungen",
    items: [
      {
        question: "Was ist eine Parodontalerkrankung?",
        answer:
          "Parodontalerkrankungen, allgemein bekannt als Zahnfleischerkrankungen, sind Infektionen des Gewebes, das Ihre Zähne an Ort und Stelle hält. Sie werden typischerweise durch schlechte Putz- und Zahnseidegewohnheiten verursacht, die es Plaque – einem klebrigen Bakterienfilm – ermöglichen, sich auf den Zähnen aufzubauen und zu verhärten.",
      },
      {
        question: "Was sind die Anzeichen einer Zahnfleischerkrankung?",
        answer:
          "Häufige Anzeichen sind rotes, geschwollenes oder empfindliches Zahnfleisch, Bluten beim Zähneputzen oder bei der Verwendung von Zahnseide, Zahnfleischrückgang, anhaltender Mundgeruch, lockere Zähne und Veränderungen beim Zusammenbeißen der Zähne.",
      },
      {
        question: "Ist eine Parodontalbehandlung schmerzhaft?",
        answer:
          "Die meisten Parodontalbehandlungen werden unter örtlicher Betäubung durchgeführt, um Ihren Komfort zu gewährleisten. Für umfangreichere Eingriffe stehen Sedierungsoptionen zur Verfügung. Beschwerden nach der Behandlung sind in der Regel minimal und können mit rezeptfreien Schmerzmitteln behandelt werden.",
      },
      {
        question: "Wie lange dauert eine Parodontalbehandlung?",
        answer:
          "Die Dauer hängt vom Schweregrad Ihrer Erkrankung ab. Erste Behandlungen erfordern möglicherweise 1-2 Termine, während fortgeschrittenere Fälle mehrere Besuche über Wochen oder Monate erfordern können. Wartungsbesuche werden in der Regel alle 3-4 Monate geplant.",
      },
      {
        question: "Kann eine Zahnfleischerkrankung rückgängig gemacht werden?",
        answer:
          "Frühe Zahnfleischerkrankungen (Gingivitis) können durch professionelle Behandlung und gute Mundhygiene rückgängig gemacht werden. Fortgeschrittene Parodontalerkrankungen können nicht vollständig rückgängig gemacht werden, aber sie können effektiv behandelt werden, um ein Fortschreiten zu verhindern und betroffene Zähne zu retten.",
      },
      {
        question: "Ist eine Zahnfleischerkrankung mit anderen Gesundheitszuständen verbunden?",
        answer:
          "Ja, Forschungen haben Zusammenhänge zwischen Parodontalerkrankungen und verschiedenen systemischen Erkrankungen wie Herzerkrankungen, Diabetes, Atemwegserkrankungen und bestimmten Schwangerschaftskomplikationen gezeigt. Die Erhaltung gesunden Zahnfleisches trägt zu Ihrem allgemeinen Wohlbefinden bei.",
      },
    ],
  },
};

export default periodontology;

